var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enableEcircularFeature
    ? _c(
        "div",
        { staticClass: "table-wrapper tenancy-e-circular-contacts" },
        [
          _c("div", { staticClass: "table-caption" }, [
            _vm._v(_vm._s(_vm.$t("tenancy.table.eCircularContacts"))),
          ]),
          _vm._v(" "),
          _vm.allowLinkContacts
            ? _c("div", { staticClass: "link__contact" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn link__contact--btn",
                    attrs: { type: "button", disabled: !_vm.tenancyId },
                    on: {
                      click: function ($event) {
                        return _vm.linkFunc({ isCircular: true })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("tenancy.table.linkContact")))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "link__contact--plus" }, [
                  _vm._v("+"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("table", [
            _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.itemHeaders, function (header, index) {
                    return _c("th", { key: index, class: header.class }, [
                      _vm._v(_vm._s(header.name)),
                    ])
                  }),
                  _vm._v(" "),
                  _c("th"),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.eCircularContacts, function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", { staticClass: "select-column" }, [
                    _c("input", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                      ],
                      attrs: {
                        type: "radio",
                        name: "primaryPerson",
                        disabled: !_vm.allowLinkContacts,
                      },
                      domProps: {
                        checked: _vm.deep(item, "CompanyContact.cPrimary"),
                      },
                      on: {
                        change: function (event) {
                          return _vm.updatePrimaryPerson(
                            index,
                            !_vm.deep(item, "CompanyContact.cPrimary")
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "number-column" }, [
                    _vm.canAccessContact
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticClass: "name-hyper-link",
                              on: {
                                click: function ($event) {
                                  return _vm.navToContactDetail(item.id, true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.displayI18nFullName(
                                    item.firstName,
                                    item.lastName
                                  ) || item.name
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isEngineer
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !!item.remarks,
                                    expression: "!!item.remarks",
                                  },
                                ],
                                staticClass: "remark-included-flag",
                              })
                            : _vm._e(),
                        ])
                      : _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.displayI18nFullName(
                                  item.firstName,
                                  item.lastName
                                ) || item.name
                              ) +
                              "\n          "
                          ),
                        ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "number-column" }, [
                    _vm._v(_vm._s(item.phone || "--")),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "select-ecircular-emails" },
                    [
                      _vm.allowLinkContacts
                        ? _c("HKLMultiSelect", {
                            staticClass: "multi-value",
                            class:
                              _vm.deep(item, "CompanyContact.cEmails")
                                .length === 0
                                ? "error-highlight-floor"
                                : "",
                            attrs: {
                              value: _vm.deep(item, "CompanyContact.cEmails"),
                              options: _vm.emailHklOptions(item),
                              placeholder: "",
                            },
                            on: {
                              change: function (val) {
                                return _vm.updatePathField(
                                  index,
                                  "cEmails",
                                  val
                                )
                              },
                            },
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .deep(item, "CompanyContact.cEmails")
                                  .join(", ") || "--"
                              )
                            ),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "select-ecircular-floors" },
                    [
                      _c("HKLMultiSelect", {
                        staticClass: "multi-value",
                        class:
                          _vm.isFloorEmptyExisting &&
                          _vm.deep(item, "CompanyContact.cFloor").length === 0
                            ? "error-highlight-floor"
                            : "",
                        attrs: {
                          disabled: !_vm.allowLinkContacts,
                          value: _vm.deep(item, "CompanyContact.cFloor"),
                          options: _vm.floorHklOptions,
                          placeholder: "",
                        },
                        on: {
                          change: function (val) {
                            return _vm.updatePathField(index, "cFloor", val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "icon-remove" }, [
                    _vm.allowLinkContacts
                      ? _c("i", {
                          staticClass: "fa fa-times-thin",
                          on: {
                            click: function ($event) {
                              return _vm.removeConfirm(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "Modal",
            {
              ref: "removePrimaryContactModal",
              attrs: { modalId: _vm.modalId },
            },
            [
              _c(
                "div",
                {
                  staticClass: "popup-hint-label",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("deleteConfirmMsg")))])]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    on: {
                      click: function ($event) {
                        return _vm.closeRemovePrimaryModal()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: {
                      click: function ($event) {
                        return _vm.removeContact(
                          _vm.deletingPrimaryContactIndex
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.yes")))]
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }